"use strict";
/**
 *
 * Baseline
 *
 */
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const styles_1 = require("./styles");
const styles = styles_1.createStyles(({ typography, palette }) => ({
    '@global': {
        '*, *::before, *::after': {
            // Change from `box-sizing: content-box` so that `width`
            // is not affected by `padding` or `border`.
            boxSizing: 'border-box',
        },
        html: {
            WebkitFontSmoothing: 'antialiased',
            MozOsxFontSmoothing: 'grayscale',
        },
        'strong, b': {
            fontWeight: typography.weights.bold,
        },
        body: Object.assign({ margin: 0, position: 'relative', backgroundColor: palette.background, color: palette.textPrimary }, typography.body),
    },
}));
const Baseline = () => React.createElement(React.Fragment, null);
const StyledBaseline = styles_1.withStyles(styles)(Baseline);
exports.Baseline = StyledBaseline;
